import { ApiTableRow } from "./ApiTableRow";
import { FileTableRow } from "./FileTableRow";
import type { TableConfig } from "./types";

const FILE_CONNECTOR_TYPES = new Set([
  "schoolmint",
  "schoolmint-enroll",
  "avela",
  "iready-sftp",
  "file-drop",
]);

interface ConnectorTableRowProps {
  table: TableConfig;
  index: number;
  onChange: (table: TableConfig) => void;
  onRemove: () => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
  connectorType: string;
}

export function ConnectorTableRow(props: ConnectorTableRowProps) {
  if (FILE_CONNECTOR_TYPES.has(props.connectorType)) {
    return <FileTableRow {...props} />;
  }
  return <ApiTableRow {...props} />;
}
